import React, { FunctionComponent } from 'react';

type Props = {
  title?: string;
};

/**
 *
 */
export const Helmet: FunctionComponent<Props> = ({ title }) => {
  if (!title) {
    return null;
  }

  return <title>{title}</title>;
};
